/**
 * Swiper-powered sliders: Featured Slider (full-bleed, one slide per
 * view), Category Slider and Trending Now (both multi-card rails, slides
 * sized by their own CSS via `slidesPerView: 'auto'`). One generic init
 * reads each `.js-slider` element's own data attributes instead of three
 * near-duplicate setups — see docs/assets.md.
 */
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-slider").forEach(function (el) {
    var wrap = el.closest(".js-slider-wrap") || el.parentElement;
    var prevEl = wrap ? wrap.querySelector(".js-slider-prev") : null;
    var nextEl = wrap ? wrap.querySelector(".js-slider-next") : null;
    var paginationEl = el.querySelector(".swiper-pagination");

    var autoplayDelay = parseInt(el.getAttribute("data-autoplay"), 10);
    var slidesPerView = el.getAttribute("data-slides-per-view") === "auto" ? "auto" : 1;
    var spaceBetween = parseInt(el.getAttribute("data-space-between"), 10) || 24;
    var loop = el.getAttribute("data-loop") === "true";

    new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: loop,
      watchOverflow: true,
      navigation: prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : false,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      autoplay: autoplayDelay
        ? { delay: autoplayDelay, disableOnInteraction: true, pauseOnMouseEnter: true }
        : false,
    });
  });
});
